// src/pages/events/Arbaeen.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Arbaeen = () => {
  return (
    <>
      <Helmet>
        <title>Arbaeen – The Largest Peaceful Pilgrimage | Ziyarat Guide</title>
        <meta
          name="description"
          content="Discover the spiritual power of Arbaeen — the world’s largest pilgrimage honoring Imam Hussain (AS). Learn its meaning, rituals, and global unity message."
        />
        <meta property="og:title" content="Arbaeen – The Largest Peaceful Pilgrimage | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Millions walk to Karbala for Arbaeen to honor Imam Hussain (AS). Explore its history, significance, and spirit of devotion."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/static/media/150-4491751897813.25777768baebc03d4b18.jpeg"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Arbaeen Pilgrimage</h1>

          <div className="content-section">
            <img
              src="https://ziyaratguide.com/static/media/150-4491751897813.25777768baebc03d4b18.jpeg"
              alt="Arbaeen Pilgrimage"
              className="imam-image"
            />

            <h2>Description</h2>
            <p>
              Arbaeen takes place 40 days after Ashura and is the largest annual pilgrimage in the world.
              Pilgrims walk from across the globe to Karbala to honor Imam Hussain (PBUH) and his ultimate
              sacrifice for truth and justice.
            </p>

            <h2>Significance</h2>
            <p>
              Arbaeen represents devotion, unity, and love for the values of justice and sacrifice upheld
              by Imam Hussain. Millions of people participate, demonstrating solidarity and commitment to
              his principles.
            </p>

            <h2>How Pilgrims Observe Arbaeen</h2>
            <ol>
              <li>
                <strong>Walking to Karbala:</strong> Pilgrims travel long distances, often on foot,
                visiting shrines and participating in processions along the way.
              </li>
              <li>
                <strong>Mourning and Reflection:</strong> Pilgrims recite elegies, prayers, and reflect
                on the sacrifices of Karbala.
              </li>
              <li>
                <strong>Acts of Service:</strong> Volunteers provide water, food, and shelter to pilgrims,
                emulating Imam Hussain’s spirit of selflessness.
              </li>
              <li>
                <strong>Community and Solidarity:</strong> Arbaeen fosters unity among diverse Muslim
                communities, reinforcing shared values of faith and justice.
              </li>
              <li>
                <strong>Personal Reflection:</strong> Pilgrims use this journey to contemplate their own
                lives and renew commitment to ethical and moral principles.
              </li>
            </ol>

            <h3>A Reflection for Pilgrims</h3>
            <blockquote>
              “As I walk these sacred paths, I honor Imam Hussain’s sacrifice, strengthen my connection to
              justice and truth, and join millions around the world in devotion and unity.”
            </blockquote>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More Events</h2>
          <ul>
            <li>
              <Link to="/events/ashura">Ashura</Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default Arbaeen;
